import dayjs from "dayjs";

export const TermUtil = {
    dueDate: (date, term) => {
        if (!date) return null;
        if (!term) return date;
        let days = 0;
        switch (term) {
            case 1:
                break;
            case 2:
                days = 15;
                break;
            case 3:
                days = 30;
                break;
            case 4:
                days = 45;
                break;
            case 5:
                days = 60;
                break;
            case 6:
                days = 90;
                break;
            case 7:
                days = 120;
                break;
            default:
                break;
        }
        return dayjs(date).add(days, 'days').valueOf();
    }
}